
import { Component, Vue } from "vue-property-decorator";
import Util from "@/lib/util";
import Pagination from "@/components/Pagination/index.vue";
import { CouponService, CouponDto } from "@/api/service-proxies";
import PagedListBase, {
  PagedRequestDto
} from "@/lib/view-base/paged-list-base";
import phoneDialog from "../components/preViewPhoneDialog.vue"
class CarousePagedRequest extends PagedRequestDto {
  Title!: string;
}

@Component({
  name: "Tenant",
  components: {
    Pagination, phoneDialog
  }
})
export default class Tenant extends PagedListBase<
  CarousePagedRequest,
  CouponDto
> {
  request = new CarousePagedRequest();
  CouponService = new CouponService();

  value = null


  value1 = ''
  value2 = ''
  created() {
    this.refresh();
  }

  getpage(finishCallback: Function): void {
    this.CouponService
      .getAll(
        this.request.Title,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then(result => {
        this.list = result.items;
        this.showPaging(result);
      })
      .finally(() => {
        finishCallback();
      });
  }
  handleCreate() {
    this.$router.push({ path: "/Coupon/create" });
  }
  handleUpdate(Coupon: CouponDto) {
    this.$router.push({ path: `/Coupon/update/${Coupon.id}` });
  }
  handleDelete(Coupon: CouponDto) {
    this.$confirm("确定删除产品?")
      .then(async () => {
        await this.CouponService.delete(Coupon.id);
        this.$notify.success("删除成功");
        this.refresh();
      })
      .catch(() => { });
  }
  openPhoneDialog(row) {
    (this.$refs.phoneDialogRef as phoneDialog).open(row)
  }

  handleDefaultSelection(index, rowData) {
  //  this.product.specificationList.map(item => {
  //      item.isSelect=false;
  //     });
  //      rowData.isSelect=true;
  //       if (rowData.id > 0) {
  //           var item = new Int64EntityDto();
  //           item.id = rowData.id;
  //           this.productCategoryService.defaultSelection(item );
  //       }
     }
}
